import { Dialog, DialogTitle, IconButton, useTheme } from '@mui/material';
import { AgencyOfficialRolesMap } from '../../';
import AddAgencyOfficialDialogForm from './AddAgencyOfficialDialogForm';
import React, { useState } from 'react';
import AddAgencyOfficialDialogUpload from './AddAgencyOfficialDialogUpload';
import { Toast } from '@components';
import AddAgencyOfficialDialogCongratulations from './AddAgencyOfficialDialogCongratulations';
import { OfficialData } from '../../../../networkRequest/officialsService';
import CloseIcon from '@mui/icons-material/Close';

type AddAgencyOfficialDialogProps = {
  onSuccess: () => void;
  open: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  roles: AgencyOfficialRolesMap;
  onClose: () => void;
};

const AddAgencyOfficialDialog = ({
  onSuccess,
  open,
  setDialogOpen,
  roles,
  onClose
}: AddAgencyOfficialDialogProps) => {
  const theme = useTheme();
  const padding = theme.spacing(3);
  const [activeStep, setActiveStep] = useState(0);

  const [errorMessage, setErrorMessage] = useState('');
  const [newOfficial, setNewOfficial] = useState<OfficialData | null>(null);

  const closeDialog = () => {
    setDialogOpen(false);
    setActiveStep(0);
    setNewOfficial(null);
    onClose();
  };

  return (
    <>
      {errorMessage && (
        <Toast type="error" onClose={() => setErrorMessage('')}>
          {errorMessage}
        </Toast>
      )}
      <Dialog
        open={open}
        onClose={closeDialog}
        maxWidth="md"
        fullWidth
        slotProps={{ backdrop: { invisible: true }, paper: { style: { borderRadius: 8 } } }}
      >
        <IconButton
          aria-label="close"
          onClick={closeDialog}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500]
          })}
        >
          <CloseIcon sx={{ fontSize: 32, color: theme.palette.grey[600] }} />
        </IconButton>
        <DialogTitle sx={{ padding, paddingBottom: '12px', fontSize: '24px' }}>New User</DialogTitle>
        {activeStep === 0 && (
          <AddAgencyOfficialDialogForm
            onSuccess={onSuccess}
            onClose={closeDialog}
            onError={setErrorMessage}
            roles={roles}
            padding={padding}
            setActiveStep={setActiveStep}
            setNewOfficial={setNewOfficial}
          />
        )}
        {activeStep === 1 && (
          <AddAgencyOfficialDialogUpload
            onSuccess={onSuccess}
            onClose={closeDialog}
            newOfficial={newOfficial}
            setActiveStep={setActiveStep}
            setErrorMessage={setErrorMessage}
          />
        )}
        {activeStep === 2 && newOfficial && (
          <AddAgencyOfficialDialogCongratulations
            newOfficial={newOfficial}
            onClose={closeDialog}
          />
        )}
      </Dialog>
    </>
  );
};

export default AddAgencyOfficialDialog;
